import { OrderMarketTypeEnum } from "../../enum/orders/market-type.enum";
import { OrderSideEnum } from '../../enum/orders/side.enum';


export class ResearchAdvice {

    public id: number;
    public symbolID: string;
    public side: OrderSideEnum.CompraAdvice | OrderSideEnum.VendaAdvice;
    public isDayTrade: boolean;
    public duration: string;
    public strategyID: number;
    public avaliable: boolean;
    public goal: number;
    public stop: number;
    public details: string;
    public market: OrderMarketTypeEnum;

    /**
     * @param adviceObject Objeto do advice.
     */
    constructor(adviceObject: any) {
        this.id = adviceObject.id || adviceObject.ID;
        this.symbolID = adviceObject.symbolID || adviceObject.SymbolID;
        this.side = adviceObject.side || adviceObject.Side;
        this.isDayTrade = adviceObject.isDayTrade || adviceObject.IsDayTrade;
        this.duration = adviceObject.duration || adviceObject.Duration;
        this.strategyID = adviceObject.strategyID || adviceObject.StrategyID;
        this.avaliable = adviceObject.avaliable || adviceObject.Avaliable;
        this.goal = adviceObject.goal || adviceObject.Goal;
        this.stop = adviceObject.stop || adviceObject.Stop;
        this.details = adviceObject.details || adviceObject.Details;
        this.market = adviceObject.market || adviceObject.Market;
    }

    static createMock(symbol: string, side: OrderSideEnum.CompraAdvice | OrderSideEnum.VendaAdvice, dayTrade: boolean, avaliable: boolean = true) {
        return {
            id: 0,
            symbolID: symbol,
            side: side,
            isDayTrade: dayTrade,
            duration: "",
            strategyID: 0,
            avaliable: avaliable,
            goal: 0,
            stop: 0,
            details: "",
            market: OrderMarketTypeEnum,
        }
    }

}